/* eslint-disable react/forbid-prop-types */
import React from 'react';
import * as XLSX from 'xlsx'; 
import { Row, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { setCurrencyFormat } from '../../../../utils/helpers';
import ResizableDataTable from '../AdvProducts/ResizableReactTableWithoutPagination';

const AdvKeywordsTable = ({ data, tableHeaderData }) => {
    const excelData = data?.length && data.map((item) => {
         const updated = { ...item };
         const { impressions, clicks, orders, units,
            sales, conversion, cost, cpc, ctr,
            acos, roas} = updated
         updated.impressions = setCurrencyFormat(Number(impressions).toFixed(0), false);  
         updated.clicks = setCurrencyFormat(Number(clicks).toFixed(0), false);
         updated.orders = setCurrencyFormat(Number(orders).toFixed(0), false);
         updated.units = setCurrencyFormat(Number(units).toFixed(0), false);
         updated.sales = setCurrencyFormat(Number(sales).toFixed(0), true);
         updated.conversion = setCurrencyFormat(Number(conversion).toFixed(0), true);
         updated.cost = setCurrencyFormat(Number(cost).toFixed(0), true);
         updated.cpc = setCurrencyFormat(Number(cpc).toFixed(0), true);     
         updated.ctr = `${Number(ctr).toFixed(2)} %`
         updated.acos = `${Number(acos).toFixed(2)} %`;
         updated.roas = setCurrencyFormat(Number(roas).toFixed(2), false);
         return updated

    })

    const handleDownload = () => {
        if (!data.length) return;

        // Create a new workbook
        const wb = XLSX.utils.book_new();
        
        // Create headers array from tableHeaderData
        const headers = tableHeaderData?.map(col => col.Header) || [];
        
        // Create data array with only the fields specified in tableHeaderData
        const worksheetData = excelData?.map(row => {
            const filteredRow = {};
            tableHeaderData?.forEach(col => {
                filteredRow[col.Header] = row[col.accessor];
            });
            return filteredRow;
        }) || [];
        
        // Convert data to worksheet format with proper headers
        const ws = XLSX.utils.json_to_sheet(worksheetData, { header: headers });
        
        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'report');
        
        // Write the file
        XLSX.writeFile(wb, 'Advertising Keywords.xlsx');
    };

    return (
        <Row style={{ position: 'relative' }}>
            <div className="ExcelTable" id='dvTable'>
                <Button
                    disabled={!data.length}
                    className="download-monthly-sub-order-report btn-primary btn btn-sm"
                    onClick={handleDownload}
                >
                    Download
                </Button>
            </div>
            <ResizableDataTable customClass="pt-0" reactTableData={{ tableHeaderData }} data={data} />
        </Row>
    )
}

AdvKeywordsTable.propTypes = {
    data: PropTypes.array.isRequired,
    tableHeaderData: PropTypes.array.isRequired,
};


export default AdvKeywordsTable;